import { FormControl, FormGroup, Validators } from "@angular/forms";

export const iosTracksFormDetails = {
    initialTrack: 'TestFlight',
    executeControlName: 'executeIos',
    trackControlName: 'iosTrack'
}

export const androidTrackFormDetails = {
    initialTrack: 'Alpha',
    executeControlName: 'executeAndroid',
    trackControlName: 'androidTrack'
}

export const tracksValidator = (group: FormGroup) => {
    if (!group) return;

    const executeIosValue = group.controls[iosTracksFormDetails.executeControlName].value;
    const executeAndroidValue = group.controls[androidTrackFormDetails.executeControlName].value;

    if (!executeIosValue && !executeAndroidValue) return { notOsSelected: true };

    return;
}

export const handleTrackControls = (group: FormGroup): void => {
    if (!group.controls[iosTracksFormDetails.trackControlName] ||
        !group.controls[iosTracksFormDetails.executeControlName] ||
        
        !group.controls[androidTrackFormDetails.trackControlName] ||
        !group.controls[androidTrackFormDetails.executeControlName]
    ) return;

    group.controls[iosTracksFormDetails.executeControlName].valueChanges.subscribe({
        next: (value) => {
          if (group.controls[iosTracksFormDetails.trackControlName] && !value) {
            group.removeControl(iosTracksFormDetails.trackControlName);
          } else {
            group.addControl(iosTracksFormDetails.trackControlName, new FormControl(iosTracksFormDetails.initialTrack, Validators.required));
          }
        }
      });
  
    group.controls[androidTrackFormDetails.executeControlName].valueChanges.subscribe({
    next: (value) => {
        if (group.controls[androidTrackFormDetails.trackControlName] && !value) {
        group.removeControl(androidTrackFormDetails.trackControlName);
        } else {
        group.addControl(androidTrackFormDetails.trackControlName, new FormControl(androidTrackFormDetails.initialTrack, Validators.required));
        }
    }
    });

    return;
}



